




































import Vue from "vue";

// Vue components
import InfoButton from "./InfoButton.vue";

// Model
import GenericConfirmationModal from "./GenericConfirmationModal.vue";

export default Vue.extend({
    components: {
        InfoButton,
        GenericConfirmationModal,
    },
    data() {
        return {
            GenericConfirmationModal,
            file: null,
            action: {},
            showConfirmationDialog: false,
            showOkAlert: false,
            showErrorAlert: false,
        };
    },
    methods: {
        openFile() {
            this.showConfirmationDialog = true;
        },

        actionSuccessfullyExecuted() {
            this.file = null;
            this.$emit("executed");
        },

        actionExecutedWithError() {
            this.file = null;
            this.showErrorAlert = true;
            this.$emit("executed");
        },
    },
});
